import Icon from '@assets/images/Hero-Icone.png';
import {
  SectionWrapper,
  StyledHr,
  ContentWrapper,
  TextBox1,
  TextBox2,
  ImageBox,
  SectionContainer,
} from './BrandSafetyFour.style';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const BrandSafetyFour = () => {
  const { t } = useTranslation('brandSafety');
  return (
    <SectionContainer>
      <SectionWrapper>
        <h1>
          {t('brandSafetyFour.title.spanBefore')}
          <span>2</span> AI
        </h1>
        <StyledHr />
      </SectionWrapper>

      <ContentWrapper>
        <TextBox1>
          <p>{t('brandSafetyFour.subtitle')}</p>
          <Link to="/contato" className="link-with-icon">
            <button>{t('brandSafetyFour.button')}</button>
          </Link>
        </TextBox1>
        <ImageBox>
          <img src={Icon} alt="Imagem" />
        </ImageBox>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default BrandSafetyFour;
